import Button from '@/components/elements/Button';
import { Icons } from '@/components/elements/Icon';

type Props = {
  filters: { key: string; value: string[] }[];
  onFilter: (key: string, value: string) => void;
};

export const CurrentRefinements = ({ filters, onFilter }: Props) => (
  <ul className="flex flex-wrap">
    {filters
      .filter((filter) => filter.value.length > 0)
      .map((filter) => (
        <li key={filter.key} className="flex flex-wrap">
          {filter.value.map((v) => (
            <Button
              key={v}
              variant="ghost"
              size="xs"
              icon={Icons.X_MARK}
              className="mr-2 mb-2"
              onClick={() => {
                onFilter(filter.key, v);
              }}
            >
              {filter.key}
              {`: ${v}`}
            </Button>
          ))}
        </li>
      ))}
  </ul>
);

export default CurrentRefinements;
